import React from 'react';
import './Page.css';

function OurName() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Our Name</h1>
        </div>
        <p>
          "YK2" is an abbreviation of "Yogah Karmasu Kaushalam". This phrase is the motto of the Indian Institute of Technology Kharagpur, 
          the alma mater of majority of the founding partners. "Yogah Karmasu Kaushalam" translates to "Excellence in action is Yoga", 
          implying that doing one's work well is true yoga.
        </p>
        <p>
          This idea can be traced back to Sri Krishna's discourse with Arjuna in Chapter 2, Verse 50 of the Bhagavad Gita, a foundational 
          philosophical Indian text. In the larger context of the Gita, the quote urges one to acquire equanimity because such a mind allows 
          one to shed distracting thoughts of the effects of deeds and concentrate on the task ahead.
        </p>
        <p>
          As bottom up, fundamental research based, long term oriented, contrarian investors who invest with an owner mindset, we find this 
          philosophy very inspiring and pertinent to our way of thinking. Our focus is on the process rather than outcome. Outcome in investing 
          is a function of skill and luck. We have no control over luck but it is our duty as craftsmen to execute our investment process 
          ("Karmasu") as skillfully ("Kaushalam") as we can, and then accept the outcome with equanimity. In essence: focus on the process, 
          pursue excellence in research, accept results with equanimity.
        </p>
      </div>
    </div>
  );
}

export default OurName;
